import * as React from "react";
/* empty css            */
const Survey = ({ title, surveyUrl }) => /* @__PURE__ */ React.createElement("div", { className: "survey-content" }, /* @__PURE__ */ React.createElement("iframe", { className: "survey-iframe", src: surveyUrl, title }));
export {
  Survey as default
};
//# sourceMappingURL=Survey.js.map
